<template>
  <div class="login-container">
    <div>
      <v-progress-linear :active="loading" :indeterminate="loading" color="#FF6D44"></v-progress-linear>

      <SafariWarning v-if="this.warning" class="warning"></SafariWarning >

      <div class="login-card">
        <img src="@/assets/logo.png" alt="MENDMate Logo" class="logo" />
        <h1 class="app-name">MENDmate</h1>
        <p class="subtitle">your therapy companion</p>

        <form @submit.prevent="signIn">
          <div class="input-group">
            <label for="username">Username</label>
            <input type="text" id="username" v-model="username" placeholder="Type a phone number or email address..."
              class="input-field" />
          </div>

          <div class="input-group">
            <label for="password">Password</label>
            <div class="password-wrapper">
              <input :type="showPassword ? 'text' : 'password'" id="password" v-model="password"
                placeholder="Type a password" class="input-field" />
              <button type="button" @click="togglePasswordVisibility" class="password-toggle">
                <i :class="showPassword ? 'mdi mdi-eye-off' : 'mdi mdi-eye'" aria-hidden="true"></i>
              </button>
            </div>
            <a @click="forgotPassword()" class="forgot-link">Forgot?</a>
          </div>



          <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>


          <button class="sign-in-btn" @click="signIn" :disabled="loading">Sign In</button>

          <p class="signup-link">
            Don't have an account? <a href="#" @click="createAccount">Create one.</a>
          </p>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import SafariWarning from './SafariWarning.vue';

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.withCredentials = true; // Enable cookies

export default {
  data() {
    return {
      username: '',
      password: '',
      showPassword: false,
      errorMessage: null,
      loading: false,
      warning: false,
    };
  },
  components: {
    SafariWarning
  },
  methods: {
    async signIn() {
      this.errorMessage = null;
      this.loading = true;
      // await this.delay(10000);
      try {
        // Send login data to your API endpoint
        const localTime = this.getLocalTime();
        console.log(`Local Time: ${localTime}`);
        console.log(axios.defaults.baseURL);
        const response = await axios.post(`/api/auth/login?date=${localTime}`, {
          username: this.username,
          password: this.password,
        }, {
          headers: {
            "X-Safari-Client": this.isSafari() ? "true" : "false"
          }
        });

        // Extract data from the API response
        const data = response.data;
        // Get the roles array from the response
        const roles = data.roles;
        let name = '';
        let loginCode = response.status;
        console.log(loginCode)
        // Conditional redirection based on user role
        if (roles.includes("Provider")) {
          // Optionally, store provider-specific info
          if (data.providerId) {
            localStorage.setItem("providerId", data.providerId);
          }
          localStorage.setItem("userRole", "provider");
          name = 'Provider';
        } else if (roles.includes("Patient")) {
          // Optionally, store patient-specific info if available (data.patientId, etc.)
          if (data.patientId) {
            localStorage.setItem("patientId", data.patientId);
          }
          localStorage.setItem("userRole", "patient");
          name = 'Assessment';
        } else if (roles.includes("Admin")) {
          localStorage.setItem("userRole", "admin");
          name = 'MenuCrud';
        } else {
          localStorage.setItem("userRole", "unknown");
          // Fallback redirection (if the role is unrecognized)
          name = 'Home';
        }
        try{
          const authResponse = await axios.get('/api/auth');
          if(authResponse == 401) this.warning = true;
        }catch(error){
          console.error(error)
          this.warning = true;
        }
        this.loading = false;
        this.$router.push({ name: name });
      } catch (error) {
        console.error(error);
        this.loading = false;
        this.errorMessage = "Login failed. Please check your credentials.";
      }
      
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    createAccount() {
      this.$router.push({ name: 'AccountSetup' });
    },
    forgotPassword() {
      this.$router.push({ name: 'ForgotPasswordPage' });
    },
    delay(time) {
      return new Promise(res => setTimeout(res, time));
    },
    /* Returns a string containing local date and time in ISO 8601 format
     Uses a wacky hack that takes advantage of the fact that the Swedish time format
     is very similar to ISO, so with a few additions we get the result we want */
    getLocaleISODate(){
      return new Date().toLocaleString('sv', {year:'numeric', month:'numeric', day:'numeric', hour:'numeric', minute:'numeric', second:'numeric', fractionalSecondDigits: 3}).replace(',', '.').replace(' ', 'T') + 'Z'
    },
    getLocalTime() {
      const now = new Date();

      // Extract date components
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
      const day = now.getDate().toString().padStart(2, '0');

      // Extract time components
      const hours = now.getHours().toString().padStart(2, '0');
      const minutes = now.getMinutes().toString().padStart(2, '0');
      const seconds = now.getSeconds().toString().padStart(2, '0');

      // Format as YYYY-MM-DD mm:ss:hh
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    },
    //a little hack that tells us if the user is using Safari or not
    isSafari(){
      //return /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
      return false;
    }
  }
}
</script>

<style scoped>
* {
  font-family: 'Montserrat', sans-serif;
}

.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #08B6AA;
}

.login-card {
  background-color: #ffffff;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  width: 300px;
}

.warning{
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  width: 300px;
}

.logo {
  width: 80px;
  margin-bottom: 0.2rem;
}

.app-name {
  font-size: 30px;
  color: #08B6AA;
  margin: 0;
}

.subtitle {
  margin: 0.5rem 0 1.5rem;
  font-size: 14px;
  color: #4A4A4A;
}

form {
  margin-top: 1rem;
}

.input-group {
  margin-bottom: 1rem;
  text-align: left;
}

.input-group label {
  display: block;
  margin-bottom: 0.3rem;
  font-size: 14px;
  color: #4A4A4A;
  font-weight: bold;
}

.input-field {
  width: 100%;
  padding: 0.5rem;
  font-size: 14px;
  border: 1px solid #DADADA;
  border-radius: 4px;
}

.input-field::placeholder {
  font-size: 10px;
}


.forgot-link {
  display: block;
  /* Ensures it doesn’t interfere with label */
  text-align: right;
  margin-top: 5px;
  font-size: 12px;
  color: #FF5722;
  text-decoration: none;
  cursor: pointer;
}

.forgot-link:hover {
  color: #08B6AA;
}

.sign-in-btn {
  width: 100%;
  padding: 0.5rem;
  background-color: #FF6D44;
  color: #fff;
  font-size: 16px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
}

.sign-in-btn:hover {
  background-color: #e64a19;
}

.sign-in-btn:disabled {
  background-color: #293840;
}

.signup-link {
  margin-top: 1rem;
  font-size: 14px;
  color: #4A4A4A;
}

.signup-link a {
  color: #FF5722;
  text-decoration: none;
}

.signup-link a:hover {
  text-decoration: underline;
}

/* error message */
.error-message {
  color: #FF5722;
  font-size: 14px;
  margin: 0.5rem 0;
  font-weight: bold;
}

/* password visibility */
.password-wrapper {
  position: relative;
}

.password-toggle {
  position: absolute;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 12px;

  cursor: pointer;
}

.password-toggle:focus {
  outline: none;
}
</style>
